import { Dic } from "@src/common/utils";
import utils from "@src/common/utils";
const tableOption = function (that) {
  return {
    page: true,
    selection: true,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    menuWidth: 200,
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    labelSuffix: " ：",
    labelWidth: "70px",
    dialogWidth: "700px",
    viewDialogWidth: "700",
    emptyText: "暂无数据",
    column: [
      {
        label: "处置卡名称",
        prop: "cardName",
        search: true,
      },
      {
        label: "处置卡设备",
        prop: "deviceName",
      },
      {
        label: "处置卡所属楼栋",
        prop: "buildingNames",
      },
      {
        label: "图片",
        prop: "fileCode",
      },
      {
        label: "备注",
        prop: "desc",
      },
    ]
  };
};
export default tableOption;
